import { Box, Flex, Image, Text } from "rebass";
import styled from "styled-components";
import { FaStar } from "react-icons/fa";

import { Button } from "../../Button";
import { ReactComponent as HistoryLogo } from "../../../Assets/Nav/nav-history.svg";
import cs2SVG from "../../../Assets/GameLogos/cs2.svg";
import theme from "../../../../theme/themeThree";
import { NAV_LINKS } from "../../Sidebar/utils";

const { REACT_APP_S3_CLIP_BUCKET } = process.env;

export const TimelineEditorInfoModal = () => {
  return (
    <StyledModalWrapper flexDirection="column">
      <Flex alignItems="center" style={{ gap: 12 }}>
        <Text
          fontWeight={700}
          fontSize={24}
          lineHeight="32px"
          color={theme.colors.ice}
        >
          Timeline Editor
        </Text>
        <Text
          fontSize="10px"
          fontWeight="600"
          color="#e8a93e"
          style={{
            background: "rgba(232, 169, 62, 0.15)",
            borderRadius: "4px",
            letterSpacing: "0.5px",
            textTransform: "uppercase",
            padding: "4px 8px",
          }}
        >
          Early Access
        </Text>
      </Flex>
      <Text
        fontWeight={500}
        fontSize={14}
        lineHeight="20px"
        color={theme.colors.chalk}
        mb={2}
      >
        Create custom highlight clips with full control over POV, timing, and
        camera angles.
      </Text>

      <ImageContainer
        onClick={() =>
          window.open(
            `${REACT_APP_S3_CLIP_BUCKET}/static/web/timeline.png`,
            "_blank",
          )
        }
      >
        <StyledFeatureImage
          src={`${REACT_APP_S3_CLIP_BUCKET}/static/web/timeline.png`}
          alt="Timeline Editor"
        />
      </ImageContainer>

      <Text
        fontWeight={600}
        fontSize={14}
        color={theme.colors.ice}
        mt={2}
        mb={1}
      >
        How to access:
      </Text>

      <StyledStep alignItems="center" style={{ gap: 12 }}>
        <StyledIcon>
          <StyledHistoryLogo width={16} height={16} />
        </StyledIcon>
        <Flex flexDirection="column">
          <Text fontWeight={600} fontSize={13} color={theme.colors.ice}>
            Open from Match History
          </Text>
          <Text fontSize={12} color={theme.colors.chalk}>
            Go to Match History, select a match, and click "Timeline Editor"
          </Text>
        </Flex>
      </StyledStep>

      <StyledStep alignItems="center" style={{ gap: 12 }}>
        <StyledIcon>
          <Image src={cs2SVG} size={16} />
        </StyledIcon>
        <Flex flexDirection="column">
          <Text fontWeight={600} fontSize={13} color={theme.colors.ice}>
            CS2 Only
          </Text>
          <Text fontSize={12} color={theme.colors.chalk}>
            Currently only available for Counter-Strike 2 matches
          </Text>
        </Flex>
      </StyledStep>

      <StyledStep alignItems="center" style={{ gap: 12 }}>
        <StyledProIcon>
          <FaStar size={14} />
        </StyledProIcon>
        <Flex flexDirection="column">
          <Text fontWeight={600} fontSize={13} color={theme.colors.ice}>
            Pro & Up Required
          </Text>
          <Text fontSize={12} color={theme.colors.chalk}>
            Clip creation is available for Pro subscribers and above
          </Text>
        </Flex>
      </StyledStep>

      <StyledButton
        onClick={() => (window.location.href = NAV_LINKS.matchHistory)}
      >
        Go to Match History
      </StyledButton>
    </StyledModalWrapper>
  );
};

const StyledModalWrapper = styled(Flex)`
  background-color: ${(props) => props.theme.colors.ned};
  border-radius: 8px;
  max-width: 640px;
  padding: 24px;
`;

const ImageContainer = styled(Box)`
  border: 1px solid ${(props) => props.theme.colors.grey825};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  margin: 16px 0;
  overflow: hidden;
  position: relative;
  transition: all 0.25s ease;
  width: 100%;

  &:hover {
    border-color: ${(props) => props.theme.colors.envy};
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.4);
    transform: translateY(-4px) scale(1.02);
  }

  &::after {
    background: rgba(0, 0, 0, 0.8);
    border-radius: 4px;
    bottom: 8px;
    color: #f7fcfd;
    content: "Click to enlarge";
    font-size: 10px;
    opacity: 0;
    padding: 4px 8px;
    position: absolute;
    right: 8px;
    transition: opacity 0.2s ease;
  }

  &:hover::after {
    opacity: 1;
  }
`;

const StyledFeatureImage = styled.img`
  display: block;
  width: 100%;
`;

const StyledStep = styled(Flex)`
  background-color: ${(props) => props.theme.colors.grey825};
  border-radius: 8px;
  padding: 12px;

  & + & {
    margin-top: 12px;
  }
`;

const StyledIcon = styled(Flex)`
  align-items: center;
  background: rgba(77, 189, 148, 0.15);
  border-radius: 50%;
  color: ${(props) => props.theme.colors.envy};
  flex-shrink: 0;
  height: 32px;
  justify-content: center;
  width: 32px;
`;

const StyledProIcon = styled(Flex)`
  align-items: center;
  background: rgba(232, 169, 62, 0.15);
  border-radius: 50%;
  color: #e8a93e;
  flex-shrink: 0;
  height: 32px;
  justify-content: center;
  width: 32px;
`;

const StyledHistoryLogo = styled(HistoryLogo)`
  fill: ${(props) => props.theme.colors.envy};
`;

const StyledButton = styled(Button)`
  background: ${(props) => props.theme.colors.envy};
  color: ${(props) => props.theme.colors.ice};
  font-weight: 600;
  margin-top: 16px;
  width: 100%;

  &:hover {
    background: ${(props) => props.theme.colors.envyDark};
  }
`;
